import React from "react";
import { checkMobileNumberExistsOrNot, fetchUserBasicDetail, saveLoanId, SaveCreditjarBusinessDetailsByData, SaveFamilyMemebersListData } from "../../AdminActionCreator.component";
import { _formatDate, basicFormValidation } from "../../../../../utils/validation";
import PopUp from "../../../../presentationals/Popup/Popup.component";



class PersonalEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popupState: false,
            popupStatus: '',
            businessDetails: {
                name1: "",
                work1: "",
                netMonthlyIncome1: "",
                name2: "",
                work2: "",
                netMonthlyIncome2: "",

            }

        }
    }


    componentDidMount() {
        const { userdata } = this.props
        console.log("use", userdata)
        let userDetail = Object.assign({}, this.state.businessDetails)



        userDetail.name1 = userdata?.[0]?.memberName ?? "",
            userDetail.work1 = userdata?.[0]?.work ?? "",
            userDetail.netMonthlyIncome1 = userdata?.[0]?.netMonthlyIncome ?? "",
            userDetail.name2 = userdata?.[1]?.memberName ?? "",
            userDetail.work2 = userdata?.[1]?.work ?? "",
            userDetail.netMonthlyIncome2 = userdata?.[1]?.netMonthlyIncome ?? "",

            this.setState({ businessDetails: userDetail })
    }
    onSubmitHandler() {
        const { admin, userdata } = this.props;

       
        const obj1 = {
            id: 1,
            memberName: this.state.businessDetails?.name1 ?? "",
            work: this.state.businessDetails?.work1 ?? "",
            netMonthlyIncome: this.state.businessDetails?.netIncome1 ?? "",
        }
        const obj2 = {
            id: 2,
            memberName: this.state.businessDetails?.name2 ?? "",
            work: this.state.businessDetails?.work2 ?? "",
            netMonthlyIncome: this.state.businessDetails?.netIncome2 ?? "",
        }
        const data = {
            userId: userdata?.[0]?.userId,
            familyMembers: [obj1, obj2]
        }



        SaveFamilyMemebersListData(
            data,
            callBack => {
                this.setState({
                    popupState: true,
                    popupStatus: 'Members Details Changed Successfully',
                    // dataChange:'yes'
                })

                this.removePopup()
            }
        )

    }
    removePopup() {
        setTimeout(
            function () {
                this.setState({ popupState: false })
            }.bind(this),
            5000
        )
    }
    closePopup() {
        this.setState({ popupState: false })
    }
    onChangeHandler(e, type) {

        let userDetail = Object.assign({}, this.state.businessDetails)
        userDetail[type] = e.target.value

        this.setState({ businessDetails: userDetail })

    }

    render() {
        const { admin, userdata } = this.props

        return (
            <div className="container details-new">
                {this.state.popupState == true ? (
                    <PopUp
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                ) : (
                    ''
                )}
                <div className="details-new background-blur" style={{ background: 'rgb(5 5 5 / 20%)', color: '#000' }}>
                    <div className="edit-box " style={{position:'absolute',top:'10%',left:'22%',zIndex:'10'}}>
                        <div className="text-right" style={{ color: 'red' }}><i onClick={() => this.props.editHandler('')} style={{ fontSize: '20px', cursor: 'pointer' }} className="fa fa-times"></i></div>

                        <h4><b>Edit Members Details</b></h4>

                        <div className="row" style={{ marginTop: '20px' }}>
                            <h5>Family Member 1</h5>
                        </div>
                        <div className="row" style={{ marginTop: '5px' }}>
                            <div className="col-sm-4 col-xs-12">
                                <label>Member Name</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.name1} onChange={(e) => this.onChangeHandler(e, "name1")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Work</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.work1} onChange={(e) => this.onChangeHandler(e, "work1")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Net Monthly Income</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.netMonthlyIncome1} onChange={(e) => this.onChangeHandler(e, "netMonthlyIncome1")} />

                            </div>


                        </div>
                        <div className="row" style={{ marginTop: '20px' }}>
                            <h5>Family Member 2</h5>
                        </div>
                        <div className="row" style={{ marginTop: '5px' }}>
                            <div className="col-sm-4 col-xs-12">
                                <label>Member Name</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.name2} onChange={(e) => this.onChangeHandler(e, "name2")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Work</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.work2} onChange={(e) => this.onChangeHandler(e, "work2")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Net Monthly Income</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.netMonthlyIncome2} onChange={(e) => this.onChangeHandler(e, "netMonthlyIncome2")} />

                            </div>


                        </div>


                        <div className="row " style={{ marginTop: '20px' }}>
                            <div className="col-xs-12">
                                <button className="btn btn-primary" id="" disabled={admin.emailId !== 'SuperUser' ? (userdata.statusId === '101' || userdata.statusId === '102' || userdata.statusId === '103' || userdata.statusId === '105' || userdata.statusId === '113' || userdata.statusId === '117' || userdata.statusId === '110' || userdata.statusId === '109') ? false : true : false} onClick={(e) => this.onSubmitHandler(e)}>
                                    Update Members Details
                                </button>
                            </div>
                        </div>





                    </div>

                </div>
            </div >
        )
    }
}
export default PersonalEdit